<div class="workspace no-back-btn" *ngIf="!showIntermediateGrouDetail">
  <div class="row" id="influencer-groups-management">
    <div class="col-md-12 influencer-group-breadcumb">
      <div class="d-flex flex-row">
        <div class="d-flex breadcumb-container">
          <div class="row flex-g1">
            <div class="col-md-8 col-sm-8">
              <div class="row">
                <div class="col-md-12 col-sm-12 breadcumb-header">
                  <div class="d-flex flex-row flex-wrap">
                    <div class="d-flex flex-row align-items-center">
                      <a class="not-underline first-line text-semi-bold-font">{{'group_influencers.breadcumb_root' | translate}}</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-sm-12 breadcumb-subheader">
                  {{'group_influencers.influencer_groups_description' | translate}}
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 d-flex justify-content-end">
              <div class="search-box-container">
                <input type="text" placeholder="{{'group_influencers.search' | translate}}" #tc="ngbTooltip" (click)="closeTooltip(tc)"
                       ngbTooltip="{{'info_box.influencer_group.search' | translate}}" placement="bottom"
                       class="page-search" [value]="searchTerm" [formControl]="searchTermControl" >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 influencer-group-dislay-list" *ngIf="!isFetchingGroups && influencerGroupList.length === 0">
      <span>{{'group_influencers.no_group_msg' | translate}}</span>
    </div>
    <div class="col-md-12 influencer-group-dislay-list">
      <div class="influencer-group-header" *ngIf="influencerGroupList.length > 0">
        <div class="d-flex flex-row flex-nowrap">
          <span *ngIf="hasNoGroup">{{'group_influencers.no_group_msg' | translate}}</span>
          <div class="d-flex flex-row flex-auto" *ngIf="!hasNoGroup">
            <div class="influencer-info d-flex flex-row flex-nowrap">
              <div class="d-flex header-title title-name group-overview-header align-items-center">
                {{'group_influencers.name-and-description' | translate}}
              </div>
              <div class="d-flex group-follower-header header-title align-items-center">
              </div>
              <div *ngIf="isRequestReview && hasPendingInfluencer" class="d-flex header-title align-items-center total_pending_influencers">
                  {{'group_influencers.pending_influencers' | translate}}
                </div>
            </div>
            <div class="d-flex flex-row influencer-kpi-block">
              <div class="influencer-avatar-list-header"></div>
              <div class="d-flex header-title reach-kpi-header flex-row align-items-center">
                <div class="reach-col">{{'group_influencers.reach' | translate}}</div>
                <achoo-icon-tooltip tooltipMsg="{{'info_box.influencer_group.reach' | translate}}"></achoo-icon-tooltip>
              </div>
              <div class="d-flex header-title engagement-kpi-header flex-row align-items-center">
                <div class="engagement-col">{{'group_influencers.engagement' | translate}}</div>
                <achoo-icon-tooltip tooltipMsg="{{'info_box.influencer_group.engagement' | translate}}"></achoo-icon-tooltip>
              </div>
              <div class="group-action-button-header"></div>
            </div>
          </div>
        </div>
      </div>
      <achoo-placeholder [placeholderId]="'influencerGroupListHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="false">
        <div *ngFor="let influencerGroup of influencerGroupList ; let lastItem = last">
          <div class="separate-line" *ngIf="lastItem"></div>
          <group-item [influencerGroup]="influencerGroup"
                      [influencerGroupList]="influencerGroupList"
                      [isLoadingRecentlyVisitedInfluencerList]="isLoadingRecentlyVisitedInfluencerList"
                      (eventAddInfluencerGroup)="onAddInfluencerGroup(influencerGroup)"
                      (eventDeleteInfluencerGroup)="showWarningDeleteInfluencerGroupPopup(influencerGroup)"
                      [listProjectOfAdvertiser]="listProjectOfAdvertiser"
                      (editGroupEvent)="showCreateGroupForm($event)"
                      (editOrCreateProjectEvent)="editOrCreateProject($event)">
          </group-item>
        </div>
      </achoo-placeholder>
    </div>
  </div>
</div>

<group-details *ngIf="showIntermediateGrouDetail"
               [influencerGroup]="newCreatedInfluencerGroup"
               #GroupDetailComponent>
</group-details>

<div class="bottombar group-bottombar" *ngIf="!isHiddenBottomBar"
     [ngClass]="{'open': isOpenBottomBar, 'collapsed': isCloseBottomBar || temporaryHidden || temporaryHiddenAddInfluencerToGroup, 'add-influencer-manually-fragment': isOpenAddInfluencerManually}">
  <div class="row full-height">
    <div class="col-md-12 col-sm-12 buttons" *ngIf="showCreateGroupButton || temporaryHiddenAddInfluencerToGroup">
      <button class="button lg-button green pull-right"
              actionByLevels="Create Group"
              [wallName]="'Groups Disabled'"
              [actionData]="invalidActionData"
              (afterChecking)="showCreateGroupForm()">{{'common.btn.create_group' | translate}}</button>
    </div>
    <div class="col-md-12" *ngIf="isShowCreateGroupForm" [ngClass]="{'temp-hidden': temporaryHidden}">
      <create-group-fragment [isShowCreateGroupForm]="isShowCreateGroupForm"
                             [groupNeedToUpdate]="groupNeedToUpdate"
                             [activePage]="activePage"
                             (cancelCreateOrUpdateGroupEvent)="cancelCreateOrUpdateGroup()"
                             (beforeCreateOrUpdateGroupEvent)="beforeCreateOrUpdateGroup($event)"
                             (afterCreateOrUpdateGroupEvent)="afterCreateOrUpdateGroup($event)">
      </create-group-fragment>
    </div>
    <div class="col-md-12 col-sm-12 d-flex" *ngIf="isShowAddInfluencerToGroup" [ngClass]="{'temp-hidden-add-influencer-group': temporaryHiddenAddInfluencerToGroup}">
      <add-influencer-group class="d-flex flex-auto"
                            [influencerGroup]="selectedInfluencerGroup"
                            [showAddInfluencerToGroupFragment]="isShowAddInfluencerToGroup"
                            [alreadySelectedInfluencers]="selectedInfluencerToAddGroup"
                            [pendingAddInfluencerToGroup]="pendingAddInfluencerToGroup"
                            (addInfluencerToGroupEvent)="addMoreInfluencerToCurrentGroup($event)"
                            (addNewInfluencerManuallyEvent)="showFragmentAddInfluencerManually($event)"
                            (closeFragmentEvent)="closeAddInfluencerToGroup($event)">
      </add-influencer-group>
    </div>
    <div class="col-md-12 col-sm-12 d-flex" *ngIf="isShowAddInfluencerManuallyFragment">
      <add-influencer-manually [influencerGroup]="selectedInfluencerGroup"
                               [influencerSuggestion]="processingInfluencerSuggestion"
                               (closeFragmentAddInfluencerManually)="closeFragmentAddInfluencerManually($event)">
      </add-influencer-manually>
    </div>
    <div class="col-md-12" *ngIf="isShowEditProject" [ngClass]="{'temp-hidden': temporaryHidden}">
      <edit-project [project]="selectedProject"
                    [activePage]="activePage"
                    [countryList]="countryList"
                    [showCountryList]="false"
                    (closeBottomBarCallback)="closeEditProject($event)"
                    (beforeCreateOrUpdateProject)="beforeCreateOrUpdateProject()">
      </edit-project>
    </div>
  </div>
</div>

<achoo-popup #WarningDeleteInfluencerGroupDialog
             modelTitle="{{'group_influencers.popup.header' | translate}}"
             cancelBtnLabel="{{'group_influencers.popup.no-keep-it' | translate}}"
             acceptBtnLabel="{{'group_influencers.popup.yes-remove' | translate}}"
             (acceptCallback)="deleteInfluencerGroup()"
             (cancelCallback)="closeWarningDeleteInfluencerGroupPopup()">
  <span>{{'group_influencers.warning-message-delete-influencer-group' | translate:{groupName: deleteGroupName} }}</span>
</achoo-popup>
<achoo-popup #AlertAddInfluencerToGroupSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{'group_details.influencer.add_influencer_to_group' | translate}}</span>
  </div>
</achoo-popup>
<achoo-popup #NotificationDeleteGroup
             [isNotification]="true"
             modelTitle="{{deletePopupTitle}}">
  <div class="d-flex flex-row flex-auto">
    <span>{{deletePopupMsg}}</span>
  </div>
</achoo-popup>
<achoo-popup #AlertRecentlyVisitedInfluencerApiFail
             acceptBtnLabel="{{'common.btn.ok' | translate}}"
             [isAlertPopup]="true"
             (acceptCallback)="closeErrorMsgModal()"
             (cancelCallback)="closeErrorMsgModal()">
  <span>{{'group_details.api_fail' | translate}}</span>
</achoo-popup>
<achoo-popup #AddInfluencerToGroupErrorPopup
             [modelTitle]="'common.alert' | translate"
             acceptBtnLabel="{{'common.btn.ok_close' | translate}}"
             [isAlertPopup]="true"
             (closeCallback)="closeErrorMsgModal()"
             (acceptCallback)="closeErrorMsgModal()">
  <div class="d-flex flex-column flex-auto">
    <span [innerHTML]="'group_details.influencer.add_infl_error_message' | translate"></span>
  </div>
</achoo-popup>
<achoo-popup #NewGroupSettingErrors
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{newGroupSettingErrorMsg}}</span>
</achoo-popup>
<achoo-popup #CreateNewGroupError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{'group_influencers.create_new_group_failed' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/influencer-groups.component.html